/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'wouter';
import { Menu } from '@micromag/core/components';
import { useUrlGenerator } from '@micromag/core/contexts';

import { useOrganisation } from '../../contexts/OrganisationContext';

import styles from '../../../styles/menus/main-guest.module.scss';

const propTypes = {
    locale: PropTypes.string,
    className: PropTypes.string,
    itemClassName: PropTypes.string,
    linkClassName: PropTypes.string,
    hideRegisterOnOrganisation: PropTypes.bool,
};

const defaultProps = {
    locale: 'fr',
    className: null,
    itemClassName: null,
    linkClassName: null,
    hideRegisterOnOrganisation: true,
};

const MainGuestMenu = ({
    locale,
    className,
    itemClassName,
    linkClassName,
    hideRegisterOnOrganisation,
    ...props
}) => {
    const url = useUrlGenerator();
    const [pathname] = useLocation();
    const organisation = useOrganisation();
    return (
        <Menu
            {...props}
            items={[
                {
                    id: 'login',
                    href: url('auth.login'),
                    label: <FormattedMessage defaultMessage="Login" description="Menu item" />,
                    active: pathname === url('auth.login'),
                },
                !hideRegisterOnOrganisation || organisation === null
                    ? {
                          id: 'register',
                          href: url('register'),
                          label: (
                              <FormattedMessage defaultMessage="Register" description="Menu item" />
                          ),
                          active: pathname === url('register'),
                      }
                    : null,
                {
                    id: 'locale',
                    href: `${pathname}?locale=${locale === 'fr' ? 'en' : 'fr'}`,
                    external: true,
                    target: '_self',
                    label:
                        locale === 'fr' ? (
                            <FormattedMessage
                                defaultMessage="English"
                                description="Locale english"
                            />
                        ) : (
                            <FormattedMessage
                                defaultMessage="Français"
                                description="Locale french"
                            />
                        ),
                    active: false,
                },
            ].filter((item) => item !== null)}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            itemClassName={itemClassName}
            linkClassName={linkClassName}
        />
    );
};

MainGuestMenu.propTypes = propTypes;
MainGuestMenu.defaultProps = defaultProps;

export default MainGuestMenu;
